import { isAuthCommunityProjection } from './auth-profile-projections.js';
import { isHomeCalendarContext } from './home-calendar-contract.js';
import { isCertificationProjection } from './certification-contracts.js';
import { readActivityListResponse } from './activity-responses.js';
import { isPersonRef } from './session-responses.js';
import { readEventListResponse } from './event-responses.js';
import { readPostFeedResponse } from './domains/posts.js';
import { readNotificationListResponse } from './notification-responses.js';
import { readHouseholdDetailResponse } from './household-responses.js';
import { readVenueListResponse } from './venue-responses.js';
import { readTreasuryFundListResponse } from './domains/treasury-fund-responses.js';
import { isUserPersonProjection, isUserHouseholdProjection } from './user-projections.js';

const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const id = value => typeof value === 'string' && value.length > 0;
const text = value => value == null || typeof value === 'string';
const date = value => value == null || typeof value === 'string' && Number.isFinite(Date.parse(value));
const statsKeys = ['activitiesCount', 'eventsCount', 'activityPeopleCount', 'eventAttendeesCount', 'communityMembersCount'];
const conforms = (reader, payload) => { try { reader(payload); return true; } catch { return false; } };
const assemblyMember = value => record(value) && id(value.id)
  && isUserPersonProjection({ ...value, _id: value.id })
  && (value.type === undefined || ['User', 'Member'].includes(value.type))
  && (value.certifications == null || isCertificationProjection(value.certifications));
const recentComment = value => record(value) && id(value.commentId) && id(value.postId)
  && typeof value.comment === 'string' && date(value.createdAt)
  && isUserPersonProjection(value.user);
const homeActivity = value => date(value.date) && date(value.createdAt)
  && (value.facilitators === undefined || Array.isArray(value.facilitators)
    && value.facilitators.every(entity => record(entity) && ['User', 'Member', 'Guest'].includes(entity.type) && isPersonRef(entity.refId)))
  && value.sessions.every(session => date(session.createdAt) && text(session.onlineLink)
    && (session.address == null || record(session.address)
      && ['streetAddress', 'suburb', 'city', 'state', 'postalCode'].every(key => text(session.address[key]))));
const homePost = value => (value.postPartial === undefined || typeof value.postPartial === 'boolean')
  && (value.likeCount === undefined || Number.isSafeInteger(value.likeCount) && value.likeCount >= 0);

export const isAuthHomeProjection = payload => record(payload)
  && (payload.calendarContext === undefined || isHomeCalendarContext(payload.calendarContext))
  && record(payload.community) && id(payload.community._id) && isAuthCommunityProjection(payload.community)
  && ['country', 'state', 'region', 'cluster'].every(key => text(payload.community[key]))
  && record(payload.stats) && statsKeys.every(key => Number.isSafeInteger(payload.stats[key]) && payload.stats[key] >= 0)
  && conforms(readActivityListResponse, payload.activities) && payload.activities.every(homeActivity)
  && conforms(readEventListResponse, { success: true, data: payload.events })
  && conforms(readPostFeedResponse, { success: true, data: payload.posts }) && payload.posts.every(homePost)
  && Array.isArray(payload.recentComments) && payload.recentComments.every(recentComment)
  && Array.isArray(payload.localSpiritualAssembly) && payload.localSpiritualAssembly.every(assemblyMember);

export function validateAuthBootSlices(payload) {
  readNotificationListResponse({ success: true, data: payload.notifications });
  if (payload.household !== null) {
    readHouseholdDetailResponse(payload.household);
    if (!isUserHouseholdProjection(payload.household)) throw new Error('Invalid household projection.');
  }
  readVenueListResponse(payload.venues);
  readTreasuryFundListResponse({ success: true, data: payload.treasuryFunds });
}
